import React from "react";
import { Filter } from "..";

interface Props {
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
}

export const IsHighlightedFilter: React.FC<Props> = ({ onClick, onClear, isActive }) => {
    return (
        <Filter
            isButton
            showDropdown={false}
            isActive={isActive}
            onClear={onClear}
            onClick={onClick}
            text="IZDVOJENE PORUKE"
            style={{ whiteSpace: "nowrap" }}
        />
    );
};
